export default function doesImageExist(url = '') {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img')
    img.onload = resolve
    img.onerror = reject
    img.src = url
  })
}
